<template>
  <CardContainer :cardTitle="title" :isEmptyData="isLoaded && dataSource != null && dataSource.data.length === 0" :titleId="'pie-chart-' + index" :participantName="dataParticipantName" :primaryColor="primaryColor" :choosenAnswers="choosenAnswers">
    <div slot="body">
      <fusioncharts type="pie2d" width="100%" height="350" dataFormat="json" :dataSource="dataSource"> </fusioncharts>
    </div>
  </CardContainer>
</template>
<script>
import _ from "lodash";
import CardContainer from "./card-container";
import { generatedPieChart } from "../../services/utils";
import { optionsPieChart } from "../../services/chart-config";

export default {
  props: {
    index: [String, Number],
    title: { type: String, default: "Default Title" },
    isLoaded: { type: Boolean, default: false },
    dataSources: [Array, null],
    primaryColor: { type: String, default: "" },
    dataParticipantName: { type: String, default: "" }
  },
  components: {
    CardContainer
  },
  data() {
    return {
      dataSource: null,
      choosenAnswers: []
    };
  },
  methods: {
    processVisualization() {
      const clonedOptions = _.cloneDeep(optionsPieChart);
      const { data, choosenAnswers } = generatedPieChart(this.dataSources, this.primaryColor, this.dataParticipantName);
      clonedOptions.data = data;
      this.dataSource = clonedOptions;
      this.choosenAnswers = choosenAnswers;
    }
  },
  mounted() {
    this.processVisualization();
  }
};
</script>
